export * from './src/restaurants-v3-order-orders.universal.js';
